<template>
  <b-card
    class="kpi-card h-100"
    :class="{ clickable: clickable }"
    body-class="py-3"
    @click="onClick"
  >
    <div class="text-muted small text-uppercase">{{ label }}</div>
    <div class="kpi-value">{{ formattedValue }}</div>
    <div v-if="comparative !== null && comparative !== undefined" class="small">
      <b-badge :variant="comparativeVariant" pill>
        <span v-if="comparativeNumber > 0">▲</span>
        <span v-else-if="comparativeNumber < 0">▼</span>
        {{ comparativeText }}
      </b-badge>
      <span v-if="comparativeLabel" class="text-muted ml-1">{{ comparativeLabel }}</span>
    </div>
    <div v-if="sub" class="text-muted small mt-1">{{ sub }}</div>
  </b-card>
</template>

<script>
export default {
  name: 'KpiCard',
  props: {
    label: { type: String, required: true },
    value: { type: [Number, String], default: 0 },
    format: { type: String, default: 'number' }, // number|money|percent|raw
    comparative: { type: [Number, String], default: null }, // % vs referencia
    comparativeLabel: { type: String, default: '' },
    sub: { type: String, default: '' },
    clickable: { type: Boolean, default: false }
  },
  computed: {
    comparativeNumber() {
      return Number(this.comparative || 0);
    },
    comparativeText() {
      const n = this.comparativeNumber;
      const sign = n > 0 ? '+' : '';
      return sign + n.toFixed(1) + '%';
    },
    comparativeVariant() {
      const n = this.comparativeNumber;
      if (n > 0) return 'success';
      if (n < 0) return 'danger';
      return 'secondary';
    },
    formattedValue() {
      if (this.format === 'raw') return this.value;
      const n = Number(this.value || 0);
      if (this.format === 'money') {
        return '$' + n.toLocaleString('es-MX', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
      }
      if (this.format === 'percent') {
        return n.toFixed(1) + '%';
      }
      return n.toLocaleString('es-MX');
    }
  },
  methods: {
    onClick() {
      if (this.clickable) this.$emit('click');
    }
  }
}
</script>

<style scoped>
.kpi-card.clickable { cursor: pointer; transition: box-shadow .15s; }
.kpi-card.clickable:hover { box-shadow: 0 0 0 2px rgba(94, 114, 228, .35); }
.kpi-value { font-size: 1.6rem; font-weight: 600; line-height: 1.2; }
</style>
